import {ArticleProductionStepSearchQueryForm} from './article-steps-copy.models';

export const articleStepsCopyListQueryKeys = {
  all: ['article', 'list', 'production', 'copyable'] as const,
  filter: (query: ArticleProductionStepSearchQueryForm) => [
    ...articleStepsCopyListQueryKeys.all,
    query,
  ] as const,
};
